import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/stores/authStore'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  requireSuperadmin?: boolean
  requireOwner?: boolean
}

export function ProtectedRoute({ children, requireSuperadmin, requireOwner }: Props) {
  const { user, hydrated } = useAuth()
  const loc = useLocation()

  if (!hydrated) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-sm text-neutral-500">Loading…</p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />
  }

  if (requireSuperadmin && user.role !== 'SUPERADMIN') {
    return (
      <div className="mx-auto max-w-xl p-8">
        <h1 className="text-xl font-semibold">Access denied</h1>
        <p className="mt-2 text-sm text-neutral-600">This area requires SUPERADMIN privileges.</p>
      </div>
    )
  }
  if (requireOwner && !['OWNER', 'SUPERADMIN'].includes(user.role)) {
    return (
      <div className="mx-auto max-w-xl p-8">
        <h1 className="text-xl font-semibold">Access denied</h1>
        <p className="mt-2 text-sm text-neutral-600">This area requires workspace owner privileges.</p>
      </div>
    )
  }

  return <>{children}</>
}
